var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBillingApproved(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    rx: 13,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1976_1040)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.6965 6.24268V8.48479H16.9386L14.6965 6.24268Z",
    fill: "#41A041"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4541 13.8682C13.4541 11.8131 15.1261 10.1412 17.1812 10.1412V9.31294H13.8683V6H7.65649V18.4235H17.1812V17.5953C15.1261 17.5953 13.4541 15.9234 13.4541 13.8682ZM9.31296 8.48471H12.6259V9.31294H9.31296V8.48471ZM12.6259 15.9388H9.31296V15.1106H12.6259V15.9388ZM12.6259 14.2824H9.31296V13.4541H12.6259V14.2824ZM12.6259 12.6259H9.31296V11.7976H12.6259V12.6259ZM13.04 10.9694H9.31296V10.1412H13.04V10.9694Z",
    fill: "#41A041"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1812 10.9693C15.5828 10.9693 14.2824 12.2697 14.2824 13.8681C14.2824 15.4666 15.5828 16.7669 17.1812 16.7669C18.7796 16.7669 20.08 15.4665 20.08 13.8681C20.08 12.2697 18.7796 10.9693 17.1812 10.9693ZM16.8884 15.1607L15.7673 14.0397L16.3529 13.454L16.8884 13.9894L18.252 12.6258L18.8376 13.2114L16.8884 15.1607ZM6.82824 6.82812H6V20.0799H16.3529V19.2517H6.82824V6.82812Z",
    fill: "#41A041"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1976_1040"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.08,
    height: 14.08,
    fill: "white",
    transform: "translate(6 6)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBillingApproved);
export default __webpack_public_path__ + "static/media/Billing Approved.5285e87f59770b64fdcf9ada9ad77b1e.svg";
export { ForwardRef as ReactComponent };